import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

const ClickableStyleLink = styled.div`
  cursor: pointer;
  color: ${themeGet("colors.primary")};
  &:hover {
    color: ${themeGet("colors.primaryDark")};
    text-decoration: underline;
  }
`;

export default ClickableStyleLink;
